<!-- <div class="row m-4">
  <div class="col-md-3">
    <app-navbar
    (send_selected_from_search_dialog)="recieve_selected_item({'text':'test','value':$event[0]})"
    [allowMultipleSelect] = "false"></app-navbar>
  </div>
  <div class="col-md-4">
    <h1><i class="fa fa-list-alt text-danger mr-1"></i> Systems Profiles <strong>Manager</strong>
    </h1>
  </div>
</div> -->


  <div class="row mt-3">
    <mat-progress-bar *ngIf=" show_progressbar==true" class="mt-1"
                      mode="query"></mat-progress-bar>

    <div class="col-lg-4 " [hidden]="!switcher_navigator">

        <form>
          <mat-form-field appearance="fill">
            <mat-label>Sort tree by</mat-label>
            <mat-select [(ngModel)]="sort_tree_by" name="item">
              <mat-option *ngFor="let item of sort_by_list" [value]="item.value">
                {{item.viewValue}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          </form>
        <app-treeview-systems
          parent_icon="folder"
          child_icon="videocam"
          parent_table_name="ngaccessmanagement_ngfoldertree"
          parent_table_pk="id"
          parent_table_ref_value="item_name"
          child_table_name="ngaccessmanagement_ngsystemprofile"
          child_table_displayname="system_name"
          child_table_fk="folder_id_id"
          algorithm="m2mtable"
          title="Location"
          [sort_by] = sort_tree_by
          [has_checkbox] = "false"
          (messageSelectedNode)="recieve_selected_item($event)"
          (messageSelectedFolder)="recieve_selected_item($event)"
        ></app-treeview-systems>
    </div>

    <div [ngClass]="{'col-lg-8 ':switcher_navigator==true,'col-sm-12 ':switcher_navigator==false}">
      <div class="m-2" id="buttons">
        <mat-slide-toggle [(ngModel)]=  "switcher_navigator">Toggle Tree</mat-slide-toggle>
        <div id="Buttonss">
          <button mat-raised-button *ngIf="adminAuthorization"
                        type="submit" id="addBtn" (click)="openDialog()">
            <mat-icon aria-hidden="false" aria-label="Add"  color="primary">add_circle</mat-icon>
            <span style="margin: 0px;padding: 0px;" >Add new system</span>
          </button>
          </div>
      </div>

        <app-system-V2

        [tree_received_endpoint_data]="items"
        [selected_parent_folder]="selected_parent_folder"
        [selected_folder]="selected_folder"
        (endPoint_location_updated)="refetchData($event)"

        ></app-system-V2>

    </div>
  </div>



